import { Button, Col, Result, Row } from 'antd';
import { Icon } from 'components';
import React from 'react';
import { AiOutlineRight } from 'react-icons/ai';
import { DownloadTable } from '../help/Download';

function RequiredApps({ history, location }) {
  return (
    <Result
      title="VD-i 서비스에 접속하려면 필수 소프트웨어가 설치되어 있어야 합니다."
      subTitle={
        <p>
          아래의 다운로드를 클릭하면 컴퓨터에 소프트웨어가 설치됩니다.
          <br />
          클라이언트가 이미 설치되어 있는 경우 넘어가기를 클릭해 주십시오.
        </p>
      }
      extra={
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Button
              size="large"
              icon={<Icon name={<AiOutlineRight />} />}
              onClick={() =>
                history.push({ pathname: '/desktops', redirectUrlToVd: location?.redirectUrlToVd })
              }
            >
              넘어가기
            </Button>
          </Col>
          <Col span={24}>
            <DownloadTable
              size="small"
              onCheckProgram={(success) => {
                if (success) {
                  history.push({
                    pathname: '/desktops',
                    redirectUrlToVd: location?.redirectUrlToVd,
                  });
                }
              }}
            />
          </Col>
        </Row>
      }
    />
  );
}

export default RequiredApps;
